import { FC } from "react";

import {
  AuditLogMetadataLabels,
  EntityPropertiesWithControls,
} from "@ryde/controls";
import { useAuditLogEventClassNames, useAuditLogMetadata } from "@ryde/redux";
import { IAuditLogNormalized, RideCrudModeKey } from "@ryde/shared";

interface IRideHistoryLogGridRowDetailsProps {
  item: IAuditLogNormalized;
  prevItem: IAuditLogNormalized | null;
}

export const RideHistoryLogGridRowDetails: FC<
  IRideHistoryLogGridRowDetailsProps
> = ({ item }) => {
  const { getMetadataText } = useAuditLogMetadata();
  const { getEventClassNames } = useAuditLogEventClassNames();

  const metadataText = getMetadataText({
    metadata: item.metadata,
    eventName: item.eventName,
    entity: item.entity,
  });
  const metadataClassNames = getEventClassNames({
    baseClassName: "ride-history-log__metadata",
    eventName: item.eventName,
    metadata: item.metadata,
  });

  const metadataLabels = (
    <AuditLogMetadataLabels
      metadataText={metadataText}
      metadataClassNames={metadataClassNames}
      metadata={item.metadata}
      metadataBadgeClassName="ride-history-log__metadata"
      className="ride-history-log__metadata-labels"
    />
  );

  return (
    <div className="ride-history-log__grid-row-details-content">
      {item.entityProperties?.length ? (
        <EntityPropertiesWithControls
          entity={RideCrudModeKey.uiUnit}
          data={item.entityProperties}
          toolbarExtra={metadataLabels}
        />
      ) : (
        metadataLabels
      )}
    </div>
  );
};
